import * as AT from "./actionTypes";
import * as MT from "./mutationTypes";
import { SET_TIME_PERIODS } from "@/modules/DashboardModule/store/mutationTypes";
import { AuthService } from "../services";
import Auth from "@/packages/auth";

export default {
  [AT.LOGIN]: (context, formData) => {
    return AuthService.login(formData)
      .then(response => {
        Auth.setToken(response.token);
        Auth.setUser(response.user);
        Auth.setTimePeriods(response.user);
        Auth.setGlobalTimePeriod(response.user);
        context.commit(MT.SET_USER, response.user);
        context.commit(MT.SET_GLOBAL_TIME_PERIOD, response.user.timePeriod);
        context.commit(SET_TIME_PERIODS, response.user.timePeriods);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.SIGN_UP]: (context, formData) => {
    return AuthService.signUp(formData)
      .then(response => {
        Auth.setToken(response.token);
        Auth.setUser(response.user);
        Auth.setTimePeriods(response.user);
        Auth.setGlobalTimePeriod(response.user);
        context.commit(MT.SET_USER, response.user);
        context.commit(MT.SET_GLOBAL_TIME_PERIOD, response.user.timePeriod);
        context.commit(SET_TIME_PERIODS, response.user.timePeriods);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.FORGOT_PASSWORD]: (context, formData) => {
    return AuthService.forgotPassword(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.VERIFY_TOKEN]: (context, formData) => {
    return AuthService.verifyToken(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.RESET_PASSWORD]: (context, formData) => {
    return AuthService.resetPassword(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_LOGGED_IN_USER]: context => {
    const user = JSON.parse(Auth.getUser());
    context.commit(MT.SET_USER, user);
    return;
  },
  [AT.GET_GLOBAL_TIME_PERIOD_FROM_STORAGE]: context => {
    const globalTimePeriod = JSON.parse(Auth.getGlobalTimePeriod());
    context.commit(MT.GET_GLOBAL_TIME_PERIOD_FROM_STORAGE, globalTimePeriod);
    return;
  },
  [AT.GET_TIME_PERIODS_FROM_STORAGE]: context => {
    const timePeriods = JSON.parse(Auth.getTimePeriods());
    context.commit(SET_TIME_PERIODS, timePeriods.timePeriods);
    return;
  }
};
